export default __webpack_public_path__ + "static/media/DanskeNarrow.dfee8673.eot";